// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3zDr-","left":"InfoRow_left__2qTBI"};